import { render, staticRenderFns } from "./SedeForm.vue?vue&type=template&id=38d05854&"
import script from "./SedeForm.vue?vue&type=script&lang=js&"
export * from "./SedeForm.vue?vue&type=script&lang=js&"
import style0 from "./SedeForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports